const initialState = {
  data: {
    accounts: [{
      type: 1,
      description: 'Conta depósito',
      futurePayment: 0,
      balance: 0,
      finalBalance: 0,
      hasFuture: false
    }]
  },
  error: false,
  isFetched: false,
  isFetching: false,
  success: false
}

export const ACTION_TYPES = {
  ACCOUNTS_POSITION_ERROR: 'ACCOUNTS_POSITION_ERROR',
  ACCOUNTS_POSITION_REQUEST: 'ACCOUNTS_POSITION_REQUEST',
  ACCOUNTS_POSITION_SUCCESS: 'ACCOUNTS_POSITION_SUCCESS'
}

export const getAccountsFinancialPosition = (payload = {}) => ({
  type: ACTION_TYPES.ACCOUNTS_POSITION_REQUEST,
  payload
})

const accountsFinancialPosition = (state = initialState, { type, payload }) => {
  switch (type) {
    case ACTION_TYPES.ACCOUNTS_POSITION_REQUEST:
      return {
        ...state,
        isFetching: true
      }
    case ACTION_TYPES.ACCOUNTS_POSITION_SUCCESS:
      return {
        ...state,
        data: {
          ...payload
        },
        error: false,
        isFetched: true,
        isFetching: false,
        success: true
      }
    case ACTION_TYPES.ACCOUNTS_POSITION_ERROR:
      return {
        ...state,
        error: true,
        isFetched: true,
        isFetching: false,
        success: false
      }
    default:
      return state
  }
}

export default accountsFinancialPosition
